import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={manga.coverImage}
          alt={manga.title}
          title={`${manga.title} - 汗汗漫画免费韩国漫画在线`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
            manga.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {manga.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-background-950/70 text-accent-400 whitespace-nowrap">
            {manga.rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8">
          <h3 className="text-sm font-semibold text-background-50 line-clamp-1 whitespace-nowrap overflow-hidden text-ellipsis">
            {manga.title}
          </h3>
        </div>
      </div>
      <div className="p-3">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-foreground-500">{manga.author}</span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {manga.views >= 10000 ? `${(manga.views / 10000).toFixed(0)}万` : manga.views}
          </span>
        </div>
        <div className="flex flex-wrap gap-1">
          {manga.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-xs rounded bg-accent-100 text-accent-800 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}